import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class BusinessLineGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkBusinessLineAccess(state.url);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkBusinessLineAccess(state.url);
  }

  private checkBusinessLineAccess(url: string): boolean {
    const userData = localStorage.getItem('currentUser');
    if (!userData) {
      this.redirectTo404();
      return false;
    }

    const user: User = JSON.parse(userData);
    const businessLines = user.business_lines || [];

    // Jika tidak memiliki business line sama sekali
    if (businessLines.length === 0) {
      this.redirectTo404();
      return false;
    }

    // Validasi business line yang valid
    const validBusinessLines = ['Hotel', 'Office Lease', 'Golf', 'Residence'];
    const hasValidBusinessLine = businessLines.some(line =>
      validBusinessLines.includes(line)
    );

    if (!hasValidBusinessLine) {
      this.redirectTo404();
      return false;
    }

    // Cek akses berdasarkan URL
    if (url.includes('/hotel')) {
      if (!businessLines.includes('Hotel')) {
        this.router.navigate(['/dashboard'], { replaceUrl: true });
        return false;
      }
    }

    if (url.includes('/office-lease')) {
      if (!businessLines.includes('Office Lease')) {
        this.router.navigate(['/dashboard'], { replaceUrl: true });
        return false;
      }
    }

    if (url.includes('/golf')) {
      if (!businessLines.includes('Golf')) {
        this.router.navigate(['/dashboard'], { replaceUrl: true });
        return false;
      }
    }

    if (url.includes('/residences')) {
      if (!businessLines.includes('Residence')) {
        this.router.navigate(['/dashboard'], { replaceUrl: true });
        return false;
      }
    }

    // Sales activities bisa diakses jika memiliki minimal 1 business line yang valid
    if (url.includes('/sales-activities')) {
      return hasValidBusinessLine;
    }

    return true;
  }

  private redirectTo404(): void {
    this.router.navigate(['/404'], {
      replaceUrl: true,
      skipLocationChange: false
    });

    // Disable browser back button
    history.pushState(null, '', window.location.href);
    window.onpopstate = () => {
      history.pushState(null, '', window.location.href);
    };
  }
}
